import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./styles/Homee.css";

const MENU_API = "https://salathai.co.tz/mrms/Menu.php";
const ORDER_API = "https://salathai.co.tz/mrms/Orders.php";
const PAYMENT_API = "https://salathai.co.tz/mrms/Payment.php";

export default function Homee() {
    const navigate = useNavigate();
    const token = localStorage.getItem("token");
    const staff = JSON.parse(localStorage.getItem("staff") || "{}");
    const [menu, setMenu] = useState([]);
    const [groups, setGroups] = useState([]);
    const [activeGroup, setActiveGroup] = useState("");
    const [cart, setCart] = useState([]);
    const [viewSide, setViewSide] = useState("order");
    const [orders, setOrders] = useState([]);
    const [darkMode, setDarkMode] = useState(false);
    const [cartModalOpen, setCartModalOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [editingOrderId, setEditingOrderId] = useState(null);
    const [editingOrderNumber, setEditingOrderNumber] = useState(null);

    const cartModalRef = useRef(null);

    // Helper function to check if a date is today
    const isToday = (dateString) => {
        const orderDate = new Date(dateString);
        const today = new Date();
        return orderDate.toDateString() === today.toDateString();
    };

    useEffect(() => {
        fetch(MENU_API).then(res => res.json()).then(data => {
            setMenu(data);
            const uniqueGroups = [...new Set(data.map(i => i.group_button))];
            const sortedGroups = uniqueGroups.sort((a, b) => a.localeCompare(b));
            setGroups(sortedGroups);
            if (data.length > 0 && sortedGroups.length > 0) {
                setActiveGroup(sortedGroups[0]);
            }
        });
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (cartModalRef.current && !cartModalRef.current.contains(event.target)) {
                setCartModalOpen(false);
            }
        };

        if (cartModalOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [cartModalOpen]);

    useEffect(() => {
        if (viewSide === "payment") {
            loadMyPendingOrders();
            const interval = setInterval(loadMyPendingOrders, 3000);
            return () => clearInterval(interval);
        }
    }, [viewSide]);

    const loadMyPendingOrders = async () => {
        try {
            const res = await fetch(`${ORDER_API}?staff_id=${staff.id}&token=${token}`);
            const data = await res.json();
            if (Array.isArray(data)) {
                // Show READY orders that are UNPAID and from today
                const pendingOrders = data.filter(order => 
                    order.status === "READY" && 
                    order.payment_status === "UNPAID" &&
                    isToday(order.created_at)
                );
                setOrders(pendingOrders);
            }
        } catch (err) {
            console.error("Load pending orders error:", err);
        }
    };

    const addToCart = (item) => {
        setCart(cart => {
            const exist = cart.find(c => c.id === item.id);
            if (exist) return cart.map(c => c.id === item.id ? { ...c, qty: c.qty + 1 } : c);
            return [...cart, { ...item, qty: 1 }];
        });
    };

    const removeFromCart = (id) => setCart(cart.filter(c => c.id !== id));
    
    const decreaseQty = (id) => {
        setCart(cart => {
            const item = cart.find(c => c.id === id);
            if (item.qty > 1) {
                return cart.map(c => c.id === id ? { ...c, qty: c.qty - 1 } : c);
            } else {
                return cart.filter(c => c.id !== id);
            }
        });
    };

    const cartTotal = cart.reduce((sum, i) => sum + i.price_tzs * i.qty, 0);
    const cartItemCount = cart.reduce((sum, i) => sum + i.qty, 0);

    const printReceipt = (orderNumber) => {
        const total = cartTotal;
        const now = new Date();
        const date = now.toLocaleDateString('en-GB');
        const time = now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
        const day = now.toLocaleDateString('en-US', { weekday: 'long' });

        const itemsHTML = cart.map(i => `
        <tr>
            <td style="padding: 8px 0;">${i.item_name}</td>
            <td style="padding: 8px 0;">${i.qty}</td>
            <td style="padding: 8px 0;">${(i.price_tzs * i.qty).toLocaleString()}</td>
        </tr>
        `).join("");

        const receiptHTML = `
        <!DOCTYPE html><html><head><title>Receipt</title><style>
        body{font-family:Arial;padding:20px;max-width:380px;margin:0 auto;background:#f5f5f5}
        .receipt{background:white;border-radius:10px;padding:20px;border:2px solid #2d6187}
        .header{text-align:center;margin-bottom:20px}
        .name{color:#2d6187;font-size:20px;font-weight:700;margin:5px 0}
        .address{font-size:12px;color:#555;margin:3px 0;line-height:1.4}
        hr{border:none;border-top:2px dashed #2d6187;margin:15px 0}
        table{width:100%;border-collapse:collapse;margin:15px 0}
        th{text-align:left;padding:10px 0;border-bottom:2px solid #2d6187;color:#2d6187}
        td{padding:8px 0;font-size:13px}
        .total-row{font-size:16px;font-weight:800;text-align:right;margin-top:10px}
        .info-grid{display:flex;flex-wrap:wrap;justify-content:space-between;font-size:13px;margin:10px 0}
        .info-item{margin:5px 0}
        @media print{body{background:white;padding:0}.receipt{border:1px solid #ddd}}
        </style></head>
        <body>
        <div class="receipt">
            <div class="header">
            <div class="name">SALATHAI RESTAURANT</div>
            <div class="address">Masaki</div>
            <div class="address">Dar es Salaam, Tanzania</div>
            <div class="address">TEL: +255 745 828 574</div>
            </div>
            <hr/>
            <div><strong>RECEIPT:</strong> ${orderNumber}</div>
            <div class="info-grid">
            <div class="info-item"><strong>Date:</strong> ${date}</div>
            <div class="info-item"><strong>Time:</strong> ${time}</div>
            <div class="info-item"><strong>Day:</strong> ${day}</div>
            </div>
            <div><strong>Waitress:</strong> ${staff.full_name}</div>
            <table>
            <thead><tr><th>ITEM</th><th>QTY</th><th>AMOUNT</th></tr></thead>
            <tbody>${itemsHTML}</tbody>
            </table>
            <div class="total-row"><strong>TOTAL:</strong> ${total.toLocaleString()} TZS</div>
        </div>
        <script>
        window.onload = function() {
            window.print();
            window.close();
        };
        </script>
        </body></html>`;

        const printWindow = window.open('', '_blank', 'width=400,height=600');
        printWindow.document.write(receiptHTML);
        printWindow.document.close();
        printWindow.focus();
    };

    const createOrder = async () => {
        if (!cart.length) {
            Swal.fire("Cart Empty", "Please add items to cart", "warning");
            return;
        }
        
        if (isSubmitting) {
            Swal.fire("Processing", "Please wait, your order is being processed...", "info");
            return;
        }
        
        setIsSubmitting(true);
        
        if (window.innerWidth < 1024) {
            setCartModalOpen(false);
        }

        const items = cart.map(c => ({ 
            menu_id: c.id, 
            quantity: c.qty,
            price: c.price_tzs
        }));
        
        // Generate unique idempotency key
        const idempotencyKey = `${staff.id}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        
        try {
            const body = { 
                items,
                staff_id: staff.id,
                idempotency_key: idempotencyKey
            };

            // If editing an existing order, include the update_order_id
            if (editingOrderId) {
                body.update_order_id = editingOrderId;
            }

            const res = await fetch(`${ORDER_API}?action=create&token=${token}`, {
                method: "POST",
                headers: { 
                    "Content-Type": "application/json",
                    "X-Idempotency-Key": idempotencyKey
                },
                body: JSON.stringify(body)
            });

            const data = await res.json();
            
            if (data.order_number) {
                if (data.already_processed) {
                    Swal.fire("Info", `Order #${data.order_number} was already processed`, "info");
                } else if (data.updated) {
                    printReceipt(data.order_number);
                    Swal.fire({
                        title: "Order Updated!",
                        html: `Order #<strong>${data.order_number}</strong> has been updated with new items.<br/>New Total: <strong>${Number(data.total_amount).toLocaleString()} TZS</strong>`,
                        icon: "success"
                    });
                } else {
                    printReceipt(data.order_number);
                    Swal.fire("Success", `Order #${data.order_number} created successfully! Ready for payment.`, "success");
                }
                setCart([]);
                setCartModalOpen(false);
                setEditingOrderId(null);
                setEditingOrderNumber(null);
                loadMyPendingOrders();
            } else {
                Swal.fire("Error", data.error || "Failed to create order", "error");
            }
        } catch (err) {
            Swal.fire("Error", "Network error occurred", "error");
        } finally {
            setIsSubmitting(false);
        }
    };

    // Add items to existing order
    const handleAddToExistingOrder = (order) => {
        setEditingOrderId(order.id);
        setEditingOrderNumber(order.order_number);
        setCart([]); // Clear cart for new items
        setViewSide("order");
        setCartModalOpen(false);
        
        Swal.fire({
            title: "Add Items to Order",
            html: `Adding items to order <strong>#${order.order_number}</strong><br/><small>Select items from the menu and click "Update Order" to add them.</small>`,
            icon: "info",
            timer: 3000,
            showConfirmButton: false,
            toast: true,
            position: 'top-end'
        });
    };

    const payOrder = async (order) => {
        if (order.status !== "READY") {
            Swal.fire("Not Ready", "Order must be READY before payment", "warning");
            return;
        }

        const { value: method } = await Swal.fire({
            title: "Payment Method",
            input: "select",
            inputOptions: { 
                CASH: "CASH", 
                "M-PESA": "M-PESA", 
                "MIX BY YAS": "MIX BY YAS", 
                SELECOM: "SELECOM", 
                "CRDB BANK": "CRDB BANK" 
            },
            inputPlaceholder: "Select payment method",
            showCancelButton: true
        });
        
        if (!method) return;
        
        try {
            const res = await fetch(`${PAYMENT_API}?action=create&token=${token}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ 
                    order_id: order.id, 
                    payment_method: method 
                })
            });
            
            const data = await res.json();
            if (data.message) {
                Swal.fire({
                    title: "Submitted!",
                    text: "Payment pending approval by cashier",
                    icon: "success",
                    timer: 1500,
                    showConfirmButton: false
                });
                loadMyPendingOrders();
            } else {
                Swal.fire("Error", data.error || "Payment failed", "error");
            }
        } catch (err) {
            Swal.fire("Error", "Network error", "error");
        }
    };

    const handleGoToHomepage = () => navigate("/");

    // Format date for display
    const formatOrderTime = (dateString) => {
        return new Date(dateString).toLocaleTimeString([], { 
            hour: '2-digit', 
            minute: '2-digit',
            hour12: true
        });
    };

    const formatOrderDate = (dateString) => {
        return new Date(dateString).toLocaleDateString([], {
            month: 'short',
            day: 'numeric'
        });
    };

    return (
        <div className={`homee-container ${darkMode ? "homee-dark" : "homee-light"}`}>
            {/* Header */}
            <header className="homee-header">
                <div className="homee-header-left">
                    <h1 className="homee-logo">SALATHAI RESTAURANT INFORMATION SYSTEM (SIS)</h1>
                </div>
                <div className="homee-header-right">
                    <div className="homee-staff-info" onClick={handleGoToHomepage}>
                        <span className="homee-staff-avatar">{staff.full_name?.charAt(0) || "U"}</span>
                        <span className="homee-staff-name">{staff.full_name}</span>
                    </div>
                    <button className="homee-theme-toggle" onClick={() => setDarkMode(!darkMode)}>
                        {darkMode ? "☀️" : "🌙"}
                    </button>
                </div>
            </header>

            {/* Editing Order Banner */}
            {editingOrderId && viewSide === "order" && (
                <div style={{
                    background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                    color: "white",
                    padding: "12px 20px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "10px"
                }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <span style={{ fontSize: "20px" }}>✏️</span>
                        <span>
                            Adding items to Order <strong>#{editingOrderNumber}</strong>
                        </span>
                    </div>
                    <button
                        onClick={() => {
                            setEditingOrderId(null);
                            setEditingOrderNumber(null);
                            setCart([]);
                        }}
                        style={{
                            background: "rgba(255,255,255,0.2)",
                            border: "1px solid white",
                            color: "white",
                            padding: "6px 16px",
                            borderRadius: "20px",
                            cursor: "pointer",
                            fontWeight: "600"
                        }}
                    >
                        Cancel Edit
                    </button>
                </div>
            )}

            {/* Navigation Tabs */}
            <nav className="homee-nav">
                <button 
                    className={`homee-nav-btn ${viewSide === "order" ? "active" : ""}`}
                    onClick={() => {
                        setViewSide("order");
                        setCartModalOpen(false);
                    }}
                >
                    Make Order
                </button>
                <button 
                    className={`homee-nav-btn ${viewSide === "payment" ? "active" : ""}`}
                    onClick={() => { 
                        setViewSide("payment"); 
                        loadMyPendingOrders(); 
                        setCartModalOpen(false);
                    }}
                >
                    Pending Payments <span className="nav-badge">{orders.length}</span>
                </button>
            </nav>

            {/* Main Content */}
            <main className="homee-main">
                {viewSide === "order" ? (
                    <div className="homee-order-layout">
                        {/* Left Sidebar - Group Categories */}
                        <aside className="homee-groups-sidebar">
                            <div className="homee-groups-header">
                                <h3>Categories</h3>
                            </div>
                            <div className="homee-groups-list">
                                {groups.map(group => (
                                    <button 
                                        key={group} 
                                        onClick={() => setActiveGroup(group)}
                                        className={`homee-group-btn ${activeGroup === group ? "active" : ""}`}
                                    >
                                        <span className="homee-group-icon">
                                            {group === "Appetizers" && "🍤"}
                                            {group === "Main Course" && "🍖"}
                                            {group === "Desserts" && "🍰"}
                                            {group === "Beverages" && "🥤"}
                                            {group === "Soups" && "🍲"}
                                            {group === "Salads" && "🥗"}
                                            {group === "Breakfast" && "🍳"}
                                            {group === "Lunch" && "🍱"}
                                            {group === "Dinner" && "🍽️"}
                                            {!group.match(/Appetizers|Main Course|Desserts|Beverages|Soups|Salads|Breakfast|Lunch|Dinner/) && "📌"}
                                        </span>
                                        <span>{group}</span>
                                    </button>
                                ))}
                            </div>
                        </aside>

                        {/* Right Side - Menu Items */}
                        <div className="homee-menu-section">
                            {!activeGroup ? (
                                <div className="homee-empty-state">
                                    <div className="homee-empty-icon"></div>
                                    <h3>Select a Category</h3>
                                    <p>Choose a category from the left sidebar to view menu items</p>
                                </div>
                            ) : (
                                <>
                                    <div className="homee-menu-header">
                                        <h2>{activeGroup}</h2>
                                        <p className="homee-menu-count">{menu.filter(i => i.group_button === activeGroup).length} items available</p>
                                    </div>
                                    <div className="homee-menu-grid">
                                        {menu
                                            .filter(item => item.group_button === activeGroup)
                                            .map(item => (
                                                <div key={item.id} className="homee-menu-item">
                                                    <div className="homee-menu-item-info">
                                                        <h4 className="homee-menu-item-name">{item.item_name}</h4>
                                                        <p className="homee-menu-item-price">{item.price_tzs.toLocaleString()} TZS</p>
                                                    </div>
                                                    <button 
                                                        className="homee-menu-item-add"
                                                        onClick={() => addToCart(item)}
                                                    >
                                                        +
                                                    </button>
                                                </div>
                                            ))}
                                    </div>
                                </>
                            )}
                        </div>

                        {/* Desktop Cart Sidebar */}
                        {cart.length > 0 && (
                            <aside className="homee-cart-sidebar">
                                <div className="homee-cart-header">
                                    <h3>{editingOrderId ? "New Items" : "Your Order"}</h3>
                                    <span className="homee-cart-badge">{cartItemCount} items</span>
                                </div>
                                <div className="homee-cart-items">
                                    {cart.map(item => (
                                        <div key={item.id} className="homee-cart-item">
                                            <div className="homee-cart-item-details">
                                                <span className="homee-cart-item-name">{item.item_name}</span>
                                                <span className="homee-cart-item-price">
                                                    {(item.price_tzs * item.qty).toLocaleString()} TZS
                                                </span>
                                            </div>
                                            <div className="homee-cart-item-actions">
                                                <button className="homee-cart-qty-btn" onClick={() => decreaseQty(item.id)}>-</button>
                                                <span className="homee-cart-qty">{item.qty}</span>
                                                <button className="homee-cart-qty-btn" onClick={() => addToCart(item)}>+</button>
                                                <button className="homee-cart-remove-btn" onClick={() => removeFromCart(item.id)}>×</button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="homee-cart-footer">
                                    <div className="homee-cart-total">
                                        <span>Total:</span>
                                        <strong>{cartTotal.toLocaleString()} TZS</strong>
                                    </div>
                                    <button 
                                        className="homee-cart-checkout" 
                                        onClick={createOrder}
                                        disabled={isSubmitting}
                                        style={editingOrderId ? { background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)" } : {}}
                                    >
                                        {isSubmitting ? "⏳ Processing..." : editingOrderId ? "✏️ Update Order" : "Place Order 🚀"}
                                    </button>
                                </div>
                            </aside>
                        )}
                    </div>
                ) : (
                    <div className="homee-payment-section">
                        <div className="homee-payment-header">
                            <h2>Pending Payments</h2>
                            <p>Orders ready for payment approval - Today Only</p>
                        </div>
                        
                        {/* Today's Date Info Banner */}
                        <div className="today-info-banner">
                            <div className="today-info-content">
                                <span className="today-icon">📅</span>
                                <span className="today-text">
                                    Showing pending orders for <strong>{new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</strong>
                                </span>
                            </div>
                            <div className="order-count-badge">
                                {orders.length} Order{orders.length !== 1 ? 's' : ''}
                            </div>
                        </div>

                        {orders.length === 0 ? (
                            <div className="homee-empty-state">
                                <div className="homee-empty-icon">📭</div>
                                <h3>No Pending Orders Today</h3>
                                <p>You have no orders ready for payment from today's date.</p>
                                <button 
                                    className="create-order-btn"
                                    onClick={() => setViewSide("order")}
                                >
                                    + Create New Order
                                </button>
                            </div>
                        ) : (
                            <div className="homee-orders-table-container">
                                <table className="homee-orders-table">
                                    <thead>
                                        <tr>
                                            <th>Order #</th>
                                            <th>Total</th>
                                            <th>Payment</th>
                                            <th>Date</th>
                                            <th>Time</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orders.map(o => (
                                            <tr key={o.id}>
                                                <td>
                                                    <div className="homee-order-number">{o.order_number}</div>
                                                </td>
                                                <td className="homee-order-total">
                                                    {Number(o.total_amount).toLocaleString()} TZS
                                                </td>
                                                <td>
                                                    <span className={`homee-payment-badge ${o.payment_status.toLowerCase()}`}>
                                                        {o.payment_status}
                                                    </span>
                                                </td>
                                                <td className="order-date-cell">
                                                    {formatOrderDate(o.created_at)}
                                                </td>
                                                <td className="order-time-cell">
                                                    {formatOrderTime(o.created_at)}
                                                </td>
                                                <td>
                                                    <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                                                        {/* ADD ITEMS BUTTON */}
                                                        <button
                                                            onClick={() => handleAddToExistingOrder(o)}
                                                            style={{
                                                                background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
                                                                color: "white",
                                                                border: "none",
                                                                padding: "8px 14px",
                                                                borderRadius: "8px",
                                                                fontSize: "13px",
                                                                fontWeight: "600",
                                                                cursor: "pointer",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "4px"
                                                            }}
                                                        >
                                                            ➕ Add Items
                                                        </button>
                                                        
                                                        {/* PAY NOW BUTTON */}
                                                        <button 
                                                            disabled={o.payment_status === "PAID" || o.status !== "READY"} 
                                                            onClick={() => payOrder(o)}
                                                            className={`homee-pay-btn ${o.payment_status === "PAID" ? "paid" : o.status === "READY" ? "ready" : "disabled"}`}
                                                        >   
                                                            {o.payment_status === "PAID" ? "✅ Paid" : o.status === "READY" ? "Pay Now" : "Not Ready"}
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                )}
            </main>

            {/* Mobile Floating Cart Button */}
            {viewSide === "order" && cart.length > 0 && (
                <div className="homee-cart-floating" onClick={() => setCartModalOpen(true)}>
                    <span className="homee-cart-floating-icon">🛒</span>
                    <span className="homee-cart-floating-count">{cartItemCount}</span>
                    <span className="homee-cart-floating-total">{cartTotal.toLocaleString()} TZS</span>
                </div>
            )}

            {/* Mobile Cart Modal */}
            {cartModalOpen && (
                <div className="homee-modal-overlay">
                    <div className="homee-cart-modal" ref={cartModalRef}>
                        <div className="homee-cart-modal-header">
                            <h3>🛒 {editingOrderId ? "New Items for Order" : `Your Order (${cartItemCount} items)`}</h3>
                            <button className="homee-cart-modal-close" onClick={() => setCartModalOpen(false)}>×</button>
                        </div>
                        {cart.length === 0 ? (
                            <div className="homee-cart-empty">
                                <div className="homee-empty-icon">🛒</div>
                                <p>Your cart is empty</p>
                            </div>
                        ) : (
                            <>
                                <div className="homee-cart-modal-items">
                                    {cart.map(item => (
                                        <div key={item.id} className="homee-cart-modal-item">
                                            <div className="homee-cart-modal-item-info">
                                                <span className="homee-cart-modal-item-name">{item.item_name}</span>
                                                <span className="homee-cart-modal-item-price">
                                                    {(item.price_tzs * item.qty).toLocaleString()} TZS
                                                </span>
                                            </div>
                                            <div className="homee-cart-modal-item-actions">
                                                <button onClick={() => decreaseQty(item.id)}>-</button>
                                                <span>{item.qty}</span>
                                                <button onClick={() => addToCart(item)}>+</button>
                                                <button onClick={() => removeFromCart(item.id)}>×</button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="homee-cart-modal-footer">
                                    <div className="homee-cart-modal-total">
                                        <span>Total:</span>
                                        <strong>{cartTotal.toLocaleString()} TZS</strong>
                                    </div>
                                    <button 
                                        className="homee-cart-modal-checkout" 
                                        onClick={createOrder}
                                        disabled={isSubmitting}
                                        style={editingOrderId ? { background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)" } : {}}
                                    >
                                        {isSubmitting ? "⏳ Processing..." : editingOrderId ? "✏️ Update Order" : "Place Order 🚀"}
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}